import * as React from 'react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCompressAlt, faArrowsLeftRight } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { TiptapButton } from '../../TiptapButton';

const MergeButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().mergeCells().run()}
         icon={<FontAwesomeIcon icon={faCompressAlt} transform={{ rotate: 45 }} />}
         title={_js('Merge Cells')}
      />
   );
};
const SplitButton = () => {
   const { editor } = useEditorContext();
   const { _js } = useLocalization();
   return (
      <TiptapButton
         onClick={() => editor.chain().focus().splitCell().run()}
         icon={<FontAwesomeIcon icon={faArrowsLeftRight} />}
         isDisabled={!editor.can().splitCell()}
         title={_js('Split Cell')}
      />
   );
};

export const MergeOrSplitButton = () => {
   const { editor } = useEditorContext();

   return editor.can().mergeCells() ? <MergeButton /> : <SplitButton />;
};
